import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class DeleteMenuApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/menu/delete',
      requesterInfo,
    })
  }

  public async deleteMenu(request: number): Promise<CommonPostResponse> {
    this.props.url = `${this.props.url}?Id=${request}`
    return await this.postAsync<CommonPostResponse>()
  }
}
